/*
 * @Description: 中文说明
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-06-29 14:33:19
 * @LastEditTime: 2019-07-24 14:41:31
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

// 发布反馈
export const releaseF = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/personal/feedback/save`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'save'
      }, params))
    }
  })
}
